import React, {useRef, useState} from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import {cacheService} from "../../services/cacheService";
import {observer} from "mobx-react-lite";
import {translationStore} from "../../store/translationStore";

const SorryToSeeYouGoPopup = observer(({isDeletedAccount}) => {
    const {translationData} = translationStore;
    const [toggle, setToggle] = useState(isDeletedAccount);
    const ref = useRef();
    const closePopup = () => {
        cacheService.set("DeletedAccount", false);
        setToggle(false);
    };

    useOnClickOutside(ref, closePopup);

    return toggle && (
        <div className="popup-holder">
            <div className="popup-body deactivate leave" ref={ref}>
                <i className="icon-close" onClick={closePopup}/>
                <h1 className="popup-body-title">{translationData?.["sorry_to_see"]}</h1>
                <h1 className="popup-body-text">{translationData?.["log_in_back"]}</h1>
                <div className="popup-buttons">
                    <button onClick={closePopup} className="pop-but send" type="button">{translationData?.["ok"]}</button>
                </div>
            </div>
        </div>
    )
})

export default SorryToSeeYouGoPopup;